import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import TrustLogos from "@/components/site/TrustLogos";
import PillarsOverview from "@/components/site/PillarsOverview";
import About from "@/components/site/About";
import PillarIntro from "@/components/site/PillarIntro";
import Services from "@/components/site/Services";
import Audiences from "@/components/site/Audiences";
import PayPerUse from "@/components/site/PayPerUse";
import Foerdermittel from "@/components/site/Foerdermittel";
import Vision from "@/components/site/Vision";
import Methodology from "@/components/site/Methodology";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function LandingPage() {
  return (
    <main className="bg-white text-[#0A0A0A]" data-testid="landing-page">
      <Header />
      <Hero />
      <TrustLogos />
      <PillarsOverview />
      <About />

      <div id="begleitung">
        <PillarIntro
          n="01"
          overline="Begleitung"
          title="Vertrieb & Führung —"
          accent="messbar wirksam."
          description="Als MHorgasConsult begleite ich Führungs­kräfte, Firmen­kunden­berater, Leasing-Vertrieb und Spezialisten in Banken, Sparkassen und Leasing­gesellschaften. Drei Jahrzehnte eigener Vertriebs­leitung bilden das Fundament."
        />
        <Audiences />
        <Services />
        <Vision />
        <Methodology />
      </div>

      <PayPerUse />
      <Foerdermittel />

      <Contact />
      <Footer />
    </main>
  );
}
